import React, { useState } from 'react'
import Axonslogo from '../../icons/header/axons.svg'
import { CardLogin, CardContainer } from './login.styles'
import { TitlePrimary } from '../../App.styles'
import '../../styleLess/signature/login.scss'
import '../../styleLess/signature/forgot.scss'
import icMail from '../../icons/forgot.svg'
import { Button, Form, Input, Modal } from 'antd'
import { useHistory } from 'react-router-dom'
import { getPathForgotPasswordInternal } from 'api/Account/forgotpasswordinternal'
import { CloseCircleOutlined } from '@ant-design/icons'

const ForgotInternalComponent = () => {
  const history = useHistory()
  const [form] = Form.useForm()
  const [valiteer, setValiteer] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [openModleError, setOpenModleError] = useState(false)

  const onFinish = (values) => {
    const handleValue = values.email
    setIsLoading(true)
    try {
      getPathForgotPasswordInternal(handleValue).then((res) => {
        if (res.status === 200) {
          const url = res.data.forgot_url
          setTimeout(() => {
            window.open(url, '_blank')
          }, 100)
          setIsLoading(false)
        } else if (res.status === 404) {
          setIsLoading(false)
          setOpenModleError(true)
        }
        setIsLoading(false)
      })
    } catch (error) {
      setIsLoading(false)
      console.log(error)
    }
  }

  const ResetManuplatinum = () => {
    setValiteer(false)
  }

  const VerifyEmailState = () => {
    return (
      <div className='multi-container-reset-and-forgot wallpaper-forgot-container'>
        <img className='icons-handle' src={icMail} />
        <h2>Forgot your password ?</h2>
        <h4>Enter your registered email below to receive password reset instruction.</h4>
        <Form form={form} onFinish={onFinish}>
          <Form.Item
            className='input-style-forgot'
            name='email'
            rules={[
              {
                type: 'email',
                required: true,
                message: '* Please enter your corporate email.',
              },
            ]}
          >
            <Input
              className={valiteer === true && 'bd-error'}
              allowClear
              size='large'
              placeholder='Email'
              onChange={ResetManuplatinum}
            />
          </Form.Item>
        </Form>
        <Button className='BTN_Next' onClick={() => form.submit()} loading={isLoading}>
          Next
        </Button>
        <h4
          className='text-link'
          onClick={() => {
            history.push({
              pathname: '/login',
            })
          }}
        >
          Return to Login
        </h4>
      </div>
    )
  }

  return (
    <CardLogin>
      <CardContainer>
        <Modal
          maskClosable={false}
          className='ShowErrorModal'
          visible={openModleError}
          open={true}
          okText={'OK'}
          onOk={() => {
            setOpenModleError(false)
          }}
          centered={true}
          cancelText
          onCancel={() => {
            setOpenModleError(false)
          }}
        >
          <CloseCircleOutlined className='CloseCircleOutlined' />
          <h2>Email Not Found</h2>
          <h4>
            The email you entered is incorrect or not found in the system. Please try
            again or contact the administrator
          </h4>
        </Modal>
        <img
          className='nav-logo'
          src={Axonslogo}
          style={{ width: '55px', height: '55px' }}
        />
        <TitlePrimary className='reponse-iproject-title'>
          {'AXONS PROJECT'}
        </TitlePrimary>
        {VerifyEmailState()}
      </CardContainer>
    </CardLogin>
  )
}

export default ForgotInternalComponent
